<script lang="ts">
  import Textfield from '@smui/textfield';

  import type { ErrorSchema, UserData } from "../types";
  import SimpleForm from './SimpleForm.svelte';

  export let submit: (event: Event) => void;
  export let formData: UserData = {
    displayName: "",
    email: "",
    password: "",
  }

  export let errors: ErrorSchema<UserData>;
</script>

<SimpleForm errors={errors} submit={submit}>
  <Textfield
    label="Display Name"
    name="displayName"
    type="text"
    variant="outlined"
    bind:value={formData.displayName}
  />

  <Textfield
    label="Email"
    name="email"
    type="email"
    variant="outlined"
    bind:value={formData.email}
  />

  <Textfield
    label="Password"
    name="password"
    type="password"
    variant="outlined"
    bind:value={formData.password}
  />
</SimpleForm>
